<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      <sales-ui-nav-breadcrumbs
        [breadCrumbs]="[
          {
            label: 'TRAINING_RESOURCES.RESOURCES_TITLE' | translate,
          },
          { label: 'TRAINING_RESOURCES.PRODUCTS_BREADCRUMB' | translate },
        ]"
      ></sales-ui-nav-breadcrumbs>
    </glxy-page-title>
  </glxy-page-toolbar>
  <ng-container *ngIf="columns$ | async as columns; else loadingState">
    <glxy-table-container
      [columns]="columns"
      [dataSource]="tableDataSource"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="defaultPageSize"
      [id]="tableId"
    >
      <div class="header">
        <glxy-table-content-header
          [showSearch]="true"
          [showFilters]="false"
          [showFiltersButton]="false"
          [showFiltersOpen]="false"
          [showSort]="false"
          [showActions]="false"
        >
        </glxy-table-content-header>
      </div>

      <table mat-table>
        <tr mat-header-row *matHeaderRowDef="[]"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: []"
          class="list-products-table-row"
          [routerLink]="row.learnMoreUrl"
        ></tr>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let product">
            <sales-ui-app-item-card-v2
              [defaultName]="product.name"
              [itemId]="product.itemId"
              [iconUrl]="product?.iconUrl"
              [requiredItems]="product?.requiredItems"
              [type]="product?.type"
              [deliveryMethod]="product?.deliveryMethod"
            ></sales-ui-app-item-card-v2>
          </td>
        </ng-container>

        <ng-container matColumnDef="retail-price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Retail price</th>
          <td mat-cell *matCellDef="let product">
            <billing-ui-price-display
              [appPrice]="product?.retailPrice?.pricesForContexts['retail']"
              [currencyCode]="product?.retailCurrency"
            ></billing-ui-price-display>
          </td>
        </ng-container>

        <ng-template #loadingShimmer>
          <div class="stencil-container">
            <div class="stencil stencil-shimmer"></div>
          </div>
        </ng-template>
      </table>
    </glxy-table-container>

    <ng-template #emptyState>
      <div class="empty-state">
        <h2 class="empty-state-title">Watch your customer base grow</h2>
        <p class="empty-state-description">Accounts that have bought your product from a reseller will show up here.</p>
      </div>
    </ng-template>
    <ng-template #filterState>
      <div class="empty-state">
        <p class="empty-state-description">No results found for your filters</p>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #loadingState>
    <div class="loading-state">
      <glxy-loading-spinner class="loading-spinner" size="large" fullHeight fullWidth></glxy-loading-spinner>
    </div>
  </ng-template>
</glxy-page>
